<template>
  <v-card outlined class="menu-card">
    <v-card-title class="app-card-title mb-0">Menu</v-card-title>

    <v-card-text class="app-card-content pl-0 pr-0 pb-0">
      <div v-if="userName" class="logged-user">
        <v-icon color="primary" class="mr-2">account_circle</v-icon>

        <div class="logged-user__content">
          <div class="logged-user__label">Usuário logado</div>
          <div class="logged-user__name">{{ userName }}</div>
        </div>
      </div>

      <v-divider v-if="userName" />

      <v-list nav dense>
        <v-list-item-group color="primary">
          <v-list-item :to="{ name: 'cpv-dashboard' }">
            <v-list-item-icon><v-icon>view_module</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'cpv-vereadores' }">
            <v-list-item-icon><v-icon>people</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Vereadores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'cpv-veiculos' }">
            <v-list-item-icon><v-icon>directions_car</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Consulta de Veículos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="logout">
            <v-list-item-icon><v-icon>exit_to_app</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'MenuCamara',

  data() {
    return {
      userName: '',
    };
  },

  mounted() {
    this.loadLoggedUser();
  },

  methods: {
    logout() {
      localStorage.removeItem('cpv_token');
      this.userName = '';
      this.$router.push({ name: 'cpv' });
    },

    loadLoggedUser() {
      const token = localStorage.getItem('cpv_token');

      if (!token) {
        this.userName = '';
        return;
      }

      this.userName = this.extractNameFromToken(token);
    },

    extractNameFromToken(token) {
      try {
        const payloadBase64 = token.split('.')[1];

        if (!payloadBase64) return '';

        const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
            .join('')
        );

        const payload = JSON.parse(jsonPayload);

        return (
          payload.nome ||
          ''
        );
      } catch (error) {
        console.error('Erro ao extrair nome do token:', error);
        return '';
      }
    },
  },
};
</script>

<style scoped>
.menu-card {
  margin-top: 0 !important;
  border-radius: 4px;
}

.menu-card .v-card-text {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.logged-user {
  display: flex;
  align-items: center;
  padding: 12px 16px;
}

.logged-user__content {
  min-width: 0;
}

.logged-user__label {
  font-size: 12px;
  color: #666;
  line-height: 1.2;
}

.logged-user__name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  word-break: break-word;
}
</style>